module.exports = __webpack_public_path__ + "img/P150T_weapon_49.f0be4e7c.png";